export default {
  state: {
    alert: {
      show: false,
      message: '',
      action: ''
    }
  },
  mutations: {
    setAlertData (state, data) {
      for (let field in data) {
        state.alert[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/global/alert.js